import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader } from 'reactstrap';
import { Formik } from 'formik';

import { Mutation } from 'react-apollo';
import { gql } from 'apollo-boost';
import TransferToVesselForm from './transferToVesselForm';
import { transferToVesselsValidationSchema } from '~/validation/transfer';

export const completeLotTransfersToVesselMutation = gql`
  mutation completeLotTransfersToVessel(
    $breweryId: Int!
    $lotTransfers: [TransferForLotTransferComplete]!
    $finishedProductVariants: [TransferForLotTransferToVessel]!
    $wastage: Float
    $costPerLitre: Float!
  ) {
    completeLotTransfersToVessel(
      breweryId: $breweryId
      lotTransfers: $lotTransfers
      wastage: $wastage
      finishedProductVariants: $finishedProductVariants
      costPerLitre: $costPerLitre
    ) {
      id
    }
  }
`;

export class ConfirmTransferToVesselModal extends Component {
  state = {
    error: null
  };

  setError = error => {
    this.setState({
      error
    });
  };

  render() {
    const { isOpen, onToggle, lotTransfers, refetchQueries, brewery, onSuccess } = this.props;
    // TODO - need to put something in here about not being able to transfer different
    // producst (if the user selects two transfer to vessel transfers and they both have
    // different products)
    const firstTransfer = lotTransfers[0];
    if (!firstTransfer) {
      return null;
    }
    const lot = firstTransfer.consolidatedLot || firstTransfer.lot;
    return (
      <Modal isOpen={isOpen} toggle={onToggle} size="lg">
        <ModalHeader toggle={onToggle}>Confirm vessel transfer</ModalHeader>
        <Mutation mutation={completeLotTransfersToVesselMutation} errorPolicy="all">
          {completeLotTransfersToVessel => {
            return (
              <Formik
                initialValues={{
                  variants: [
                    {
                      quantity: 0,
                      packagingCost: 0,
                      taxPerLitre: 0
                    }
                  ],
                  wastage: 0,
                  trackFinishedVariants: true,
                  costPerLitre: lot.product.costPerLitre
                }}
                validationSchema={transferToVesselsValidationSchema}
                validateOnChange={false}
                validateOnBlur={false}
                render={p => (
                  <TransferToVesselForm product={lot.product} {...this.props} {...p} error={this.state.error} />
                )}
                onSubmit={async (values, { setErrors, setSubmitting }) => {
                  setSubmitting(true);

                  try {
                    await completeLotTransfersToVessel({
                      variables: {
                        wastage: values.trackFinishedVariants ? values.wastage : 0,
                        breweryId: brewery.id,
                        costPerLitre: values.costPerLitre,
                        lotTransfers: lotTransfers.map(l => ({
                          id: l.id
                        })),
                        finishedProductVariants: values.trackFinishedVariants
                          ? values.variants.map(({ quantity, productVariantId, packagingCost, taxPerLitre }) => ({
                              quantity,
                              productVariantId,
                              packagingCost,
                              taxPerLitre
                            }))
                          : []
                      },
                      awaitRefetchQueries: true,
                      refetchQueries
                    });
                    onSuccess();
                  } catch (err) {
                    console.error(err);
                    this.setError(err);
                    setSubmitting(false);
                  }
                }}
              />
            );
          }}
        </Mutation>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(ConfirmTransferToVesselModal);



// WEBPACK FOOTER //
// ./src/containers/confirmTransferToVesselModal/confirmTransferToVesselModal.jsx